


import axiosInstance from '../../config';

export const fetchSymbolService = async ( token, data) => {

  try {


    const response = await axiosInstance.post('/ui/fetch-symbol', 
      data,{
         headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },

    }) 
  

 


    return {
      success: true,
      data: response.data,
      status: response.status,

    };


  }
  catch (error) {
   
    return {
      success: false,
      message: error.response?.data?.message || "Response failed",
      status: error.response?.status || 500,
      errors: error.response?.data?.errors || null,


    };

  }


};



